import * as state from '@/components/Analysis/modules/cuboids/state';
import { CuboidState } from '@/modules/cuboids/types';
import { AnalysisCuboid } from '@/types';

const {
  currentCuboid,
  editingCuboids,
  cuboidClickMode,
  cuboidTransformMode,
  isCuboidEditorEnabled,
  isCuboidVisibilityBoxEnabled,
  referenceCuboid,
  isAddingWorkscope,
  cuboidResizeStep,
} = state;

const cuboidState = {
  currentCuboid,
  cuboids: editingCuboids,
  cuboidClickMode,
  cuboidTransformMode,
  isCuboidEditorEnabled,
  isCuboidVisibilityBoxEnabled,
  referenceCuboid,
  isAddingWorkscope,
  cuboidResizeStep,
};

export const useCuboidState = (): CuboidState<AnalysisCuboid> => {
  return cuboidState;
};
